import { inject } from '@angular/core';
import { AuthService } from '../infrastructure/auth.service';
import { HttpErrorResponse, HttpInterceptorFn, HttpStatusCode } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { ErrorCodes } from '../models/error-codes.model';
export const authErrorInterceptor: HttpInterceptorFn = (request, next) => {
  const authService = inject(AuthService);

  const router = inject(Router);

  return next(request).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === HttpStatusCode.Unauthorized) {
        authService.redirectToLogin();
      }

      if (error.status === HttpStatusCode.Forbidden) {
        const errorCode = error.error?.errorCode;

        // Redirect to a custom forbidden page
        if (errorCode === ErrorCodes.NoSupplierId) {
          router.navigate(['/authentication-error']);
        } else {
          router.navigate(['/forbidden']);
        }
      }

      return throwError(() => error);
    }),
  );
};
